// extracted by mini-css-extract-plugin
export var dropdown = "_r4-0";
export var imageWrapper = "_r4-3";
export var itemNameContainer = "_r4-1";
export var productImage = "_r4-2";
export var spinnerWrapper = "_r4-4";